import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  RoleAssignmentWithRelationsDto,
  ResponseDto,
} from "@mimber/schema"
import { roleAssignmentsKeys } from "../roles.utils"

/**
 * Organization-specific hook for fetching role assignments for a specific role
 * Can only be used in mimber-organization app
 */
export const useRoleAssignments = (
  roleUuid: string,
  options?: UseQueryOptions<
    ResponseDto<RoleAssignmentWithRelationsDto[]>,
    Error
  >
): UseQueryResult<ResponseDto<RoleAssignmentWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useRoleAssignments")

  const { server } = useServerContext()

  return useQuery({
    queryKey: roleAssignmentsKeys.findByRole(roleUuid),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<RoleAssignmentWithRelationsDto[]>
      >(`roles/${roleUuid}/assignments`)
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!roleUuid,
    ...options,
  })
}
